import { EntityValidationResponse } from '@epicuro-next/data/engagement/document-control/models';
import { createAction, props } from '@ngrx/store';

export const upsertValidators = createAction(
  '[Document Control] Upsert Validators',
  props<EntityValidationResponse>(),
);
